import React from 'react';
import { Link } from '@mui/material';
import ExperianLogo from './images/experianLogo.png';
import EquifaxLogo from './images/equifaxLogo.svg';

export const PROMPTS = {
  PROMPT_VERIFY_PHONE_MFA: 'PROMPT_VERIFY_PHONE_MFA',
  PROMPT_ADDRESS: 'PROMPT_ADDRESS',
  PROMPT_CIP: 'PROMPT_CIP',
  PROMPT_REPAIR_INFO: 'PROMPT_REPAIR_INFO',
  PROMPT_GENERATE_DECISION: 'PROMPT_GENERATE_DECISION',
  PROMPT_PREQUAL_APPROVED: 'PROMPT_PREQUAL_APPROVED',
  PROMPT_PII_RETRY: 'PROMPT_PII_RETRY',
  PROMPT_CUSTOMER_REVOLVING_OFFER: 'PROMPT_CUSTOMER_REVOLVING_OFFER',
  PROMPT_CUSTOMER_INSTALLMENT_OFFER: 'PROMPT_CUSTOMER_INSTALLMENT_OFFER',
  PROMPT_PREQUAL_DECLINED: 'PROMPT_PREQUAL_DECLINED',
  PROMPT_CUSTOMER_FROZEN: 'PROMPT_CUSTOMER_FROZEN',
  PROMPT_CUSTOMER_LOCKED: 'PROMPT_CUSTOMER_LOCKED',
  PROMPT_CUSTOMER_NOT_IDENTIFIED: 'PROMPT_CUSTOMER_NOT_IDENTIFIED',
  PROMPT_REFER_OPP_LOANS: 'PROMPT_REFER_OPP_LOANS',
  PROMPT_MANUAL_REVIEW: 'PROMPT_MANUAL_REVIEW',
  PROMPT_EXTERNAL_ERROR: 'PROMPT_EXTERNAL_ERROR',
  PROMPT_CUSTOMER_UNFREEZE_FAILED: 'PROMPT_CUSTOMER_UNFREEZE_FAILED',
  PROMPT_UNFREEZE_LIMIT_REACHED: 'PROMPT_UNFREEZE_LIMIT_REACHED',
  PROMPT_CUSTOMER_UNLOCK_FAILED: 'PROMPT_CUSTOMER_UNLOCK_FAILED',
  PROMPT_UNLOCK_LIMIT_REACHED: 'PROMPT_UNLOCK_LIMIT_REACHED',
};

export const NATIONAL_ID_ALREADY_EXISTS = 'NATIONAL_ID_ALREADY_EXISTS';
export const COULD_NOT_VERIFY_ADDRESS = 'COULD_NOT_VERIFY_ADDRESS';
export const INVALID_VERIFICATION_CODE = 'INVALID_VERIFICATION_CODE';
export const PHONE_PRESENT_ON_EXISTING_ACCOUNT = 'PHONE_PRESENT_ON_EXISTING_ACCOUNT';

export const CREDIT_BUREAUS = {
  EXPERIAN: 'EXPERIAN',
  EQUIFAX: 'EQUIFAX',
};

export const EXPERIAN_DETAILS = {
  name: 'Experian',
  logo: ExperianLogo,
  phone: '(888) 397-3742',
  url: 'https://usa.experian.com/login/index?it=frz',
};

export const EQUIFAX_DETAILS = {
  name: 'Equifax',
  logo: EquifaxLogo,
  phone: '(888) 298-0045',
  url: 'https://www.equifax.com/personal/credit-report-services/credit-freeze/',
};

export const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
export const percentFormat = new Intl.NumberFormat('en-US', { style: 'percent', maximumSignificantDigits: 4 });

export const WEBBANK_DISCLAIMER = (
  <>
    All credit products are issued by WebBank. You must be at least 18 years old to apply.
    The prequalification process involves a review of your creditworthiness but will not
    affect your credit score. Going through the prequalification process does not guarantee
    your application will be approved. By continuing with the application process, you may
    be evaluated for multiple credit products, and upon submitting the full application by
    clicking “Accept Offer,” a one-time hard inquiry will be made and may have an impact on
    your credit score for a period of time.
  </>
);

export const PHONE_DISCLAIMER = (
  <>
    <b>Consent to Use of Telephone Numbers:</b>
    {' '}
    You authorize WebBank, DigniFi, their
    affiliates, agents, and others calling at their request or on their behalf to contact
    you at any number (i) you have provided to us (ii) from which you have called us, or
    (iii) which we obtain and believe we can reach you at. We may contact you in any way,
    such as calling, texting, using an automated dialer or using pre-recorded messages.
    We may contact you on a mobile, wireless, or similar device, even if you are charged
    for it by your provider.
  </>
);

export const TEXT_DISCLAIMER = (
  <>
    <b>Text Messaging Disclosure and authorization:</b>
    {' '}
    Message and data rates may apply.
    Reply STOP to
    {' '}
    <Link href="sms:95679&body=STOP" sx={{ textDecorationColor: 'inherit', color: 'inherit' }}>95679</Link>
    {' '}
    to cancel. Reply HELP to
    {' '}
    <Link href="sms:95679&body=HELP" sx={{ textDecorationColor: 'inherit', color: 'inherit' }}>95679</Link>
    {' '}
    for help. Call
    {' '}
    <Link href="tel:+18558085861" sx={{ textDecorationColor: 'inherit', color: 'inherit' }}>(855) 808-5861</Link>
    {' '}
    for support.
  </>
);

export const ROADSIDE_ASSISTANCE_PRICING_TYPE = 2;
